import { parse } from 'qs';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';

import { openTBankModal } from './TBankModal';
import { TBANK_PROMO_ID } from './TBankSub.helpers';

export const useTBankFromQuery = () => {
    const { search } = useLocation();
    const queryParams = parse(search, { ignoreQueryPrefix: true });
    const storage = useSelector(getCurrentStorage);
    const email = useSelector(UserSelectors.getEmail);
    const isFromTBank = queryParams?.welcome === 'tbank' && storage === EStorageType.home && email;
    const isTooltipShown = Boolean(storeHelper.getValue(TBANK_PROMO_ID));

    useEffect(() => {
        if (isFromTBank && !isTooltipShown) {
            openTBankModal();
        }
    }, [isFromTBank]);
};
